import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

export default {
  isDirty(state) {
    if (isEmpty(state.master)) return false;
    return !isEqual(state.draft, state.master);
  },
};
